import React from 'react'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/plugins/line-numbers/prism-line-numbers.css'
import 'prismjs/plugins/command-line/prism-command-line.css'
import Root from './src/components/root'

export const wrapRootElement = ({ element }) => {
  return <Root>{element}</Root>
}
